<script>
export default {
  props: {
    value: {
      type: String,
      default: 'right-bottom',
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      positions: [
        'left-top', 'center-top', 'right-top',
        'left-middle', 'center-middle', 'right-middle',
        'left-bottom', 'center-bottom', 'right-bottom',
      ],
    };
  },
  methods: {
    selectPosition(position) {
      this.$emit('input', position);
    },
  },
};
</script>

<template>
  <div class="compbps p-2">
    <input
      type="hidden"
      :id="id"
      v-model="value"
    />
    <div class="columns is-mobile is-multiline">
      <div v-for="position in positions" :key="position" class="column is-4 p-1">
        <button
          type="button"
          class="button is-fullwidth p-0"
          :class="{ 'is-primary': value === position }"
          style="height: 40px; position: relative; z-index: 1;"
          @click="selectPosition(position)"
        />
      </div>
    </div>
  </div>
</template>
